/**
 * RachaBanner · v6.7.2 F2
 * Banner compacto con la racha activa más alta del user. Aparece junto a header.
 */
import { useState, useEffect } from "react";
import { api } from "../api/client.js";
import { Flame } from "../lib/icons.jsx";
import { cn } from "../lib/utils.js";

const RACHA_LABEL = {
  dia_verde:        "días de constancia",
  sin_apelacion:    "días sin apelar",
  ftr:              "FTR",
  cliente_aprueba:  "cliente aprueba",
};

export default function RachaBanner({ userId }) {
  const [racha, setRacha] = useState(null);

  useEffect(() => {
    if (!userId) return;
    api.getGamifProfile(userId)
      .then(p => {
        // Solo la racha de Constancia (días laborables con el día cerrado): es la que sale del cierre real.
        const top = (p.rachas || []).find(r => r.tipo === "dia_verde" && (r.dias_actuales || 0) >= 2);
        if (top) setRacha(top);
      })
      .catch(() => {});
  }, [userId]);

  if (!racha) return null;

  const dias = racha.dias_actuales || 0;
  const tier = dias >= 90 ? "diamante" : dias >= 30 ? "oro" : dias >= 7 ? "naranja" : "calor";
  const styles = {
    // SOA 10 PRO · chip de gestión en píldora suave (el verde #E7F6EE/#047857 es el de «sin apelaciones»)
    diamante: "bg-[#E0F7FB] text-[#0E7490]",
    oro:      "bg-[#FEF9C3] text-[#854D0E]",
    naranja:  "bg-[#FFEDD5] text-[#C2410C]",
    calor:    "bg-[#E7F6EE] text-[#047857]",
  };

  return (
    <a href="/mi-perfil" className={cn(
      "inline-flex items-center gap-1.5 px-4 h-[46px] rounded-full text-[14px] font-extrabold transition-transform hover:scale-[1.03]",
      styles[tier]
    )} title={`Constancia: ${dias} días laborables seguidos con el día cerrado · récord ${racha.dias_record}. Fines de semana, feriados, licencias y días sin tareas no la cortan.`}>
      <Flame className={cn("h-5 w-5", tier === "diamante" && "animate-pulse")} />
      <span>{dias}</span>
      <span className="font-semibold opacity-80 hidden sm:inline">{RACHA_LABEL[racha.tipo] || racha.tipo}</span>
    </a>
  );
}
